import styled from 'styled-components'
import theme from 'vars/theme'
import { Button } from 'reactstrap'

export const FormBlockWrapper = styled.div`
  padding: 1rem;
  border-bottom: 1px solid ${theme.grayPrimary};
  margin-bottom: ${(props) => props.hasMarginButton && '70px'};
`

export const ButtonWrapper = styled(Button)`
  &:focus {
    box-shadow: none;
  }
`
